import { useEffect } from "react";
import { Outlet, Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, ButtonBase, Stack, Typography } from "@mui/material";

import NavBar from "../../components/navBar/navBar";
import { USER_ROLES, CRO_RELATED_ROLES } from "../../utils/constants";
import useGetSummaryTrial from "../../hooks/useGetSummaryTrial";

const SUMMARY_ROLES = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.CRO,
  USER_ROLES.CRO_COORDINATOR,
  USER_ROLES.DATA_MANAGER,
  USER_ROLES.CRC,
  USER_ROLES.INVESTIGATOR,
  USER_ROLES.SUB_INVESTIGATOR,
  USER_ROLES.REVIEWER,
];

const TrialLayout = () => {
  const { _id_ } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;

  const isSuperAdmin = role === USER_ROLES.SUPER_ADMIN;
  const canViewConfiguration =
    CRO_RELATED_ROLES.includes(role) || isSuperAdmin || role === USER_ROLES.REVIEWER;

  const tabs = [
    SUMMARY_ROLES.includes(role) && { label: "Trial Summary", value: "summary" },
    isSuperAdmin && { label: "Trial Hierarchy", value: "hierarchy" },
    canViewConfiguration && { label: "Trial Configuration", value: "configuration" },
    isSuperAdmin && { label: "Trial Documents", value: "documents" },
  ].filter(Boolean);

  const { data: summaryTrial } = useGetSummaryTrial({ trialId: _id_ });

  const activeTab = tabs.find((tab) => location.pathname.endsWith(`/${tab.value}`))?.value ?? false;

  useEffect(() => {
    const isAtRoot = location.pathname.replace(/\/$/, "") === `/clinic_trials/${_id_}`;
    if (isAtRoot && tabs.length > 0) {
      navigate(`/clinic_trials/${_id_}/${tabs[0].value}`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, _id_]);

  return (
    <Box sx={{ maxWidth: "95%", mx: "auto" }}>
      <NavBar active="trials" />

      {tabs.length > 0 && (
        <Stack
          direction="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
          gap={1}
          backgroundColor="#f1f1f1"
          sx={{ p: 2, pt: 1, mb: 2.5 }}
        >
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {tabs.map((tab) => (
              <ButtonBase
                key={tab.value}
                component={Link}
                to={`/clinic_trials/${_id_}/${tab.value}`}
                data-testid={`trial-tab-${tab.value}`}
                sx={{
                  px: 2,
                  py: 1.5,
                  backgroundColor: activeTab === tab.value ? "#EE295D" : "white",
                  color: activeTab === tab.value ? "white" : "#EE295D",
                  "&:hover": {
                    backgroundColor: "#EE295D",
                    color: "white",
                  },
                }}
              >
                <Typography fontSize="0.85rem" fontWeight="fontWeightBold">
                  {tab.label}
                </Typography>
              </ButtonBase>
            ))}
          </Stack>

          {summaryTrial?.name && (
            <Typography sx={{ fontWeight: 700, pr: 1 }}>Name: {summaryTrial.name}</Typography>
          )}
        </Stack>
      )}

      <Outlet />
    </Box>
  );
};

export default TrialLayout;
